import { render, staticRenderFns } from "./ADteacher.vue?vue&type=template&id=6bc7e9b2&scoped=true"
import script from "./ADteacher.vue?vue&type=script&lang=js"
export * from "./ADteacher.vue?vue&type=script&lang=js"
import style0 from "./ADteacher.vue?vue&type=style&index=0&id=6bc7e9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc7e9b2",
  null
  
)

export default component.exports